import { readStore } from "./storefrontService.ts";

export interface StoreSearchResult {
  key: string;
  kind: "master" | "variant";
  masterProductId: number;
  variantId?: number;
  title: string;
  masterTitle: string;
  masterSlug: string;
  variantAddressTitle?: string;
  code?: string;
}

export async function searchStoreCatalog(search: string): Promise<StoreSearchResult[]> {
  const term = encodeURIComponent(search.trim());
  const [masters, variants] = await Promise.all([
    readStore(`products?search=${term}&pageSize=4`),
    readStore(`variants?search=${term}`),
  ]);
  return [
    ...masters.items.map(function (product): StoreSearchResult {
      return {
        key: `master-${product.id}`, kind: "master", masterProductId: product.id,
        title: product.title, masterTitle: product.title, masterSlug: product.slug,
      };
    }),
    ...variants.slice(0, 8).map(function (variant): StoreSearchResult {
      return {
        key: `variant-${variant.id}`, kind: "variant", masterProductId: variant.masterProductId,
        variantId: variant.id, title: variant.title, masterTitle: variant.masterTitle,
        masterSlug: variant.masterSlug, variantAddressTitle: variant.addressTitle,
        code: variant.code,
      };
    }),
  ];
}
